<div class="miq-quarter-selector-overlay">
  <div class="label">{{ label }}</div>
  <div class="months-quarters-header">
    <div *ngIf="requiredYear" class="mq-select-wrapper">
      <mat-select
        hideSingleSelectionIndicator="true"
        [(ngModel)]="selectedYear"
        (selectionChange)="otherYearSelected()"
        disableOptionCentering
      >
        <mat-select-trigger class="selected-year">
          {{ selectedYear }}
        </mat-select-trigger>
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div
    *ngIf="!isYearlySelector"
    [ngClass]="{ 'monthly-selector': isMonthlySelector, 'quarter-selector': !isMonthlySelector }"
    class="months-quarters"
  >
    <ng-container *ngFor="let quarter of quartersAndMonths">
      <div class="quarter" [class.disabled]="quarter.disabled" (click)="clickOnQuarter($event, quarter)">
        <span [class.selected]="thisSelection === quarter.value" class="quarter-title">
          {{ quarter.name }}
        </span>
        <ng-container *ngFor="let month of quarter.months">
          <span
            [ngClass]="{
              selected: thisSelection === month.value,
              disabled: month.disabled,
            }"
            class="month"
            (click)="clickOnMonth($event, month)"
          >
            {{ month.name }}
          </span>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
